var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.5,9v-2.5c0-1.933,1.567-3.5,3.5-3.5h0c1.933,0,3.5,1.567,3.5,3.5v2.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-color": "color-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14,8H6c-1.6543,0-3,1.3457-3,3v4c0,1.6543,1.3457,3,3,3h8c1.6543,0,3-1.3457,3-3v-4c0-1.6543-1.3457-3-3-3Zm-3,5.5c0,.5522-.4473,1-1,1s-1-.4478-1-1v-1c0-.5522.4473-1,1-1s1,.4478,1,1v1Z",
    strokeWidth: 0,
    fill: "currentColor"
  })));
};
export default SvgLock;